import styled from 'styled-components';
import {Typography} from '@/components/Typography';
import {interceptProps} from '@/styled-components/utils';
import {palette} from '@/styles';

export const SidePanelHead = styled.div`
  border-bottom: solid 1px ${palette.gray200};
`;

export const SidePanelHeadTitleSection = styled.div`
  height: 58px;
  display: flex;
  align-items: center;
  padding: 0 16px;
`;

export const SidePanelHeadTitleText = styled(Typography).attrs({
  variant: 'medium16',
  color: palette.textPrimary,
  fontWeight: 700,
})``;

export const SidePanelFilterSection = styled.div`
  padding: 8px;
`;

export const SidePanelFilterRow = styled.div`
  & + & {
    margin-top: 8px;
  }
`;

export const SidePanelFilterGroup = styled('div').withConfig({
  shouldForwardProp: interceptProps(['evenly']),
})<{
  evenly?: boolean;
}>`
  display: flex;
  gap: 8px;
  ${({evenly}) =>
    evenly &&
    `
  & > * {
    flex-grow: 1;
    flex-basis: 0;
  }
  `}
`;

export const SidePanelSortBar = styled.div`
  display: flex;
  align-items: center;
  height: 32px;
  padding: 0 16px;
  background-color: ${palette.bgGray100};
  gap: 12px;
`;
